export const CONTACT = {
    phone1: "8777797857",
    phone2: "8583938574",
    whatsappNumber: "918777797857",
    email: "brightensupport@gmail.com",
    instagram: "https://www.instagram.com/tiyasha_samanta06?vrfl=Y3dhYWswNTMzMDM4",
    facebook: "https://www.facebook.com/share/1F2woEgREm/",
    twitter: "https://x.com/BrghtenService",
};

export const waLink = (text) =>
    `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text || "Hi Brighten Services, I need appliance repair service")}`;

export const SERVICE_IMAGES = {
    ac: "https://images.unsplash.com/photo-1665826254141-bfa10685e002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxzcGxpdCUyMGFpciUyMGNvbmRpdGlvbmVyJTIwdGVjaG5pY2lhbiUyMHJlcGFpcnxlbnwwfHx8fDE3OTIzMDkyMjR8MA&ixlib=rb-4.1.0&q=85",
    fridge: "https://images.unsplash.com/photo-1630459065645-549fe5a56db4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxkb3VibGUlMjBkb29yJTIwcmVmcmlnZXJhdG9yJTIwb3BlbnxlbnwwfHx8fDE3OTIzMDkzMTN8MA&ixlib=rb-4.1.0&q=85",
    microwave: "https://images.unsplash.com/photo-1585659722983-3a675dabf23d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxtaWNyb3dhdmUlMjBvdmVuJTIwcmVwYWlyfGVufDB8fHx8MTc5MjMwODg1M3ww&ixlib=rb-4.1.0&q=85",
    washing: "https://images.unsplash.com/photo-1622473590925-e3616c0a41bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx3YXNoaW5nJTIwbWFjaGluZSUyMGZyb250JTIwbG9hZGVyfGVufDB8fHx8MTc5MjMwODg1OHww&ixlib=rb-4.1.0&q=85",
    geyser: "https://images.unsplash.com/photo-1575299737366-39c143459bc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHx3YXRlciUyMGhlYXRlciUyMGdleXNlciUyMHRhbmt8ZW58MHx8fHwxNzkyMzA4ODU4fDA&ixlib=rb-4.1.0&q=85",
    ro: "https://images.unsplash.com/photo-1669211659110-3f3db4119b65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx3YXRlciUyMHB1cmlmaWVyJTIwZmlsdGVyJTIwUk98ZW58MHx8fHwxNzkyMzA4ODU4fDA&ixlib=rb-4.1.0&q=85",
    hero: "https://images.pexels.com/photos/33671149/pexels-photo-33671149.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    area: "https://images.unsplash.com/photo-1556910633-5099dc3971e8?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const APPLIANCE_VALUES = ["AC", "Refrigerator", "Microwave", "Washing Machine", "Geyser / Water Heater", "RO Water Purifier", "Other"];

export const translations = {
    en: {
        meta: { title: "Brighten Services | Home Appliance Repair in Kolkata, West Bengal" },
        topbar: { service: "24/7 Service", languages: "English • Hindi • Bengali" },
        nav: { home: "Home", services: "Services", howItWorks: "How It Works", areas: "Service Areas", faqs: "FAQs", contact: "Contact" },
        cta: { call: "Call Now", alternate: "Alternate Call", whatsapp: "WhatsApp", book: "Book a Service" },
        hero: {
            badge: "24/7 Doorstep Service Available",
            titleLines: ["Home Appliance Repair", "at Your Doorstep", "in Kolkata"],
            subtitle: "Fast and convenient repair and maintenance support for household appliances across Kolkata, Sonarpur, and North 24 Parganas.",
            serving: "Serving Kolkata, West Bengal",
            card1: "24/7 Availability",
            card2: "EN • HI • BN Support",
        },
        marquee: ["AC Repair", "Refrigerator Repair", "Microwave Repair", "Washing Machine", "Geyser Service", "RO Water Purifier", "24/7 Doorstep Service", "Kolkata • Sonarpur • North 24 Parganas"],
        services: {
            heading: "Our Services",
            sub: "Repair and maintenance for every essential home appliance — one call away.",
            book: "Book This Service",
            commonProblems: "Common problems we fix",
            ctaCard: { title: "Not sure what's wrong?", text: "Describe the issue and a technician will inspect it at your doorstep before any repair begins.", button: "Request a Visit" },
            items: {
                ac: { title: "Air Conditioner Repair & Maintenance", tagline: "Repair, installation & regular servicing", desc: "Keep your AC running efficiently with repair, installation, and regular servicing.", problems: ["Not cooling properly", "Water leakage", "Gas leakage", "Unusual noise", "Installation issues"] },
                fridge: { title: "Refrigerator Repair", tagline: "All refrigerator types", desc: "Diagnosis and repair for common refrigerator faults.", problems: ["Cooling issues", "Excessive ice formation", "Compressor problems", "Door seal issues", "Temperature fluctuations"] },
                microwave: { title: "Microwave Repair", tagline: "All household microwave ovens", desc: "Repair and maintenance for household microwave ovens.", problems: ["Not heating", "Display issues", "Power failures", "Button malfunctions", "Sparking concerns"] },
                washing: { title: "Washing Machine Repair", tagline: "Semi & fully automatic", desc: "Service support for semi-automatic and fully automatic washing machines.", problems: ["Drainage issues", "Spin problems", "Water inlet faults", "Vibration and noise", "Power issues"] },
                geyser: { title: "Geyser Repair & Installation", tagline: "Water heater specialists", desc: "Professional troubleshooting and installation support.", problems: ["No heating", "Water leakage", "Thermostat issues", "Power problems", "Installation assistance"] },
                ro: { title: "RO Water Purifier Service", tagline: "Service & maintenance", desc: "Routine servicing and repair support for RO systems.", problems: ["Low water flow", "Filter replacement needs", "Water quality concerns", "Leakage issues", "Maintenance servicing"] },
            },
        },
        how: {
            heading: "How It Works",
            sub: "Three simple steps between you and a working appliance.",
            steps: [
                { title: "Choose a Service", desc: "Select the appliance or service you need." },
                { title: "Schedule a Visit", desc: "Call, WhatsApp, or submit the service request form." },
                { title: "Inspection & Repair Estimate", desc: "A technician inspects the appliance and provides a repair estimate before work proceeds." },
            ],
        },
        why: {
            heading: "Why Choose Brighten Services",
            priority: "Your Satisfaction Is Our Priority",
            sub: "Simple, honest doorstep service — nothing more, nothing less. Your Satisfaction Is Our Priority.",
            points: [
                "24/7 service availability — every day of the year",
                "Support in English, Hindi & Bengali",
                "Technician inspection and a clear estimate before any repair begins",
                "We offer a 30-day warranty on labor and service workmanship, plus standard manufacturer warranties on any new spare parts installed",
            ],
        },
        areas: {
            heading: "Service Areas",
            sub: "We currently serve",
            list: ["Kolkata", "Sonarpur", "North 24 Parganas", "West Bengal"],
            notSureTitle: "Not sure if you're covered?",
            notSureText: "Contact us by phone or WhatsApp and share your address or PIN code.",
            notSureCta: "Ask on WhatsApp",
        },
        reviews: {
            heading: "Customer Reviews",
            title: "No reviews yet",
            text: "No customer reviews have been provided yet. We publish only genuine reviews from actual customers.",
        },
        faq: {
            heading: "Frequently Asked Questions",
            sub: "Straight answers, no fine print.",
            items: [
                { q: "How do I book a service?", a: "You can call, WhatsApp, or use the booking form." },
                { q: "Is there an inspection charge?", a: "Yes, a nominal inspection charge applies to cover the technician's visit and diagnosis. This fee is waived if you proceed with the suggested repair." },
                { q: "Will I receive an estimate before repair?", a: "Yes, the technician provides a detailed inspection and repair estimate before commencing any work. Repairs only begin after your approval." },
                { q: "Are spare parts included?", a: "No, spare parts are charged separately based on actual replacement requirements, unless specifically covered under an active service package or maintenance agreement." },
                { q: "Is there a service warranty?", a: "Yes, we offer a 30-day warranty on labor and service workmanship, plus standard manufacturer warranties on any new spare parts installed." },
                { q: "What payment methods do you accept?", a: "We accept Cash, UPI (Google Pay, PhonePe, Paytm), Net Banking, and Credit/Debit Cards upon completion of the service." },
                { q: "Do you service my area?", a: "We currently serve Kolkata, Sonarpur, and North 24 Parganas. Contact us to confirm coverage." },
            ],
        },
        form: {
            heading: "Request Service",
            sub: "Fill the form and our team will contact you shortly.",
            infoTitle: "Book a doorstep visit",
            infoPoints: ["Technician inspects before any repair", "Clear estimate before work begins", "Available 24/7 across our service areas"],
            labels: { fullName: "Full Name", phone: "Phone Number", areaPin: "Area / PIN Code", appliance: "Appliance Type", issue: "Issue Description", date: "Preferred Visit Date", time: "Preferred Visit Time" },
            placeholders: { fullName: "Your full name", phone: "e.g. 98300 00000", areaPin: "e.g. Garia / 700084", appliance: "Select appliance", issue: "Briefly describe the problem", date: "Pick a date", time: "Select a time slot" },
            applianceOptions: ["AC", "Refrigerator", "Microwave", "Washing Machine", "Geyser / Water Heater", "RO Water Purifier", "Other"],
            timeOptions: ["As soon as possible", "Today — Afternoon (12–4 PM)", "Today — Evening (4–8 PM)", "Tomorrow — Morning"],
            privacy: "Your contact information will be used only for responding to your service request.",
            needDate: "Please pick a visit date.",
            submit: "Request Service",
            submitting: "Submitting…",
            successTitle: "Request received",
            successText: "Thank you. Your service request has been received. Our team will contact you shortly.",
            successWhatsApp: "Also confirm instantly on WhatsApp",
            newRequest: "Make another request",
            error: "Something went wrong. Please try again or call us directly.",
        },
        contact: {
            heading: "Contact Us",
            sub: "Reach us any time — we are open 24/7.",
            phone: "Phone",
            whatsapp: "WhatsApp",
            email: "Email",
            hours: "Business Hours",
            hoursValue: "Open 24/7",
            languages: "Languages",
            languagesValue: "English, Hindi, Bengali",
            instagram: "Instagram",
        },
        footer: {
            tagline: "Doorstep home appliance repair across Kolkata, Sonarpur & North 24 Parganas.",
            quickLinks: "Quick Links",
            contactTitle: "Contact",
            rights: "Brighten Services, Kolkata, West Bengal. All rights reserved.",
        },
        sticky: { call: "Call Now", whatsapp: "WhatsApp" },
    },
    hi: {
        meta: { title: "ब्राइटन सर्विसेज़ | कोलकाता, पश्चिम बंगाल में होम एप्लायंस रिपेयर" },
        topbar: { service: "24/7 सेवा", languages: "English • हिंदी • বাংলা" },
        nav: { home: "होम", services: "सेवाएँ", howItWorks: "कैसे काम करता है", areas: "सेवा क्षेत्र", faqs: "सामान्य प्रश्न", contact: "संपर्क" },
        cta: { call: "कॉल करें", alternate: "वैकल्पिक कॉल", whatsapp: "व्हाट्सएप", book: "सर्विस बुक करें" },
        hero: {
            badge: "24/7 डोरस्टेप सेवा उपलब्ध",
            titleLines: ["होम एप्लायंस रिपेयर", "अब आपके द्वार पर", "कोलकाता में"],
            subtitle: "कोलकाता, सोनारपुर और उत्तर 24 परगना में घरेलू उपकरणों के लिए तेज़ और सुविधाजनक मरम्मत व रखरखाव सेवा।",
            serving: "कोलकाता, पश्चिम बंगाल में सेवा",
            card1: "24/7 उपलब्धता",
            card2: "EN • HI • BN सहायता",
        },
        marquee: ["एसी रिपेयर", "रेफ्रिजरेटर रिपेयर", "माइक्रोवेव रिपेयर", "वाशिंग मशीन", "गीज़र सर्विस", "आरओ वाटर प्यूरीफायर", "24/7 डोरस्टेप सेवा", "कोलकाता • सोनारपुर • उत्तर 24 परगना"],
        services: {
            heading: "हमारी सेवाएँ",
            sub: "हर ज़रूरी घरेलू उपकरण की मरम्मत और रखरखाव — बस एक कॉल दूर।",
            book: "यह सेवा बुक करें",
            commonProblems: "सामान्य समस्याएँ जो हम ठीक करते हैं",
            ctaCard: { title: "समझ नहीं आ रहा क्या खराबी है?", text: "समस्या बताएँ — कोई भी मरम्मत शुरू होने से पहले तकनीशियन आपके घर आकर जाँच करेगा।", button: "विज़िट का अनुरोध करें" },
            items: {
                ac: { title: "एयर कंडीशनर रिपेयर और मेंटेनेंस", tagline: "रिपेयर, इंस्टॉलेशन और नियमित सर्विसिंग", desc: "रिपेयर, इंस्टॉलेशन और नियमित सर्विसिंग से अपना एसी कुशलता से चलाए रखें।", problems: ["ठंडक ठीक से नहीं हो रही", "पानी का रिसाव", "गैस रिसाव", "असामान्य आवाज़", "इंस्टॉलेशन समस्याएँ"] },
                fridge: { title: "रेफ्रिजरेटर रिपेयर", tagline: "सभी प्रकार के रेफ्रिजरेटर", desc: "रेफ्रिजरेटर की सामान्य खराबियों की जाँच और मरम्मत।", problems: ["कूलिंग की समस्या", "अत्यधिक बर्फ जमना", "कंप्रेसर की समस्या", "दरवाज़े की सील खराब", "तापमान में उतार-चढ़ाव"] },
                microwave: { title: "माइक्रोवेव रिपेयर", tagline: "सभी घरेलू माइक्रोवेव ओवन", desc: "घरेलू माइक्रोवेव ओवन की मरम्मत और रखरखाव।", problems: ["गर्म नहीं हो रहा", "डिस्प्ले समस्या", "पावर फेलियर", "बटन खराब", "स्पार्किंग की समस्या"] },
                washing: { title: "वाशिंग मशीन रिपेयर", tagline: "सेमी और फुली ऑटोमैटिक", desc: "सेमी-ऑटोमैटिक और फुली-ऑटोमैटिक वाशिंग मशीन के लिए सर्विस सहायता।", problems: ["पानी निकासी की समस्या", "स्पिन की समस्या", "पानी इनलेट फॉल्ट", "कंपन और शोर", "पावर की समस्या"] },
                geyser: { title: "गीज़र रिपेयर और इंस्टॉलेशन", tagline: "वॉटर हीटर विशेषज्ञ", desc: "पेशेवर ट्रबलशूटिंग और इंस्टॉलेशन सहायता।", problems: ["पानी गर्म नहीं हो रहा", "पानी का रिसाव", "थर्मोस्टेट समस्या", "पावर की समस्या", "इंस्टॉलेशन सहायता"] },
                ro: { title: "आरओ वाटर प्यूरीफायर सर्विस", tagline: "सर्विस और रखरखाव", desc: "आरओ सिस्टम के लिए नियमित सर्विसिंग और मरम्मत सहायता।", problems: ["पानी का प्रवाह कम", "फिल्टर बदलने की ज़रूरत", "पानी की गुणवत्ता की चिंता", "रिसाव की समस्या", "रखरखाव सर्विस"] },
            },
        },
        how: {
            heading: "कैसे काम करता है",
            sub: "आपके और काम करते उपकरण के बीच बस तीन आसान कदम।",
            steps: [
                { title: "सेवा चुनें", desc: "अपना उपकरण या आवश्यक सेवा चुनें।" },
                { title: "विज़िट शेड्यूल करें", desc: "कॉल करें, व्हाट्सएप करें, या सर्विस रिक्वेस्ट फॉर्म भरें।" },
                { title: "निरीक्षण और मरम्मत का अनुमान", desc: "तकनीशियन उपकरण की जाँच करता है और काम शुरू करने से पहले मरम्मत का अनुमान देता है।" },
            ],
        },
        why: {
            heading: "ब्राइटन सर्विसेज़ ही क्यों",
            priority: "आपकी संतुष्टि ही हमारी प्राथमिकता है",
            sub: "सीधी, ईमानदार डोरस्टेप सेवा — न ज़्यादा, न कम। आपकी संतुष्टि ही हमारी प्राथमिकता है।",
            points: [
                "24/7 सेवा उपलब्धता — साल के हर दिन",
                "अंग्रेज़ी, हिंदी और बंगाली में सहायता",
                "कोई भी मरम्मत शुरू होने से पहले तकनीशियन जाँच और स्पष्ट अनुमान",
                "हम श्रम और सर्विस वर्कमैनशिप पर 30-दिन की वारंटी देते हैं, साथ ही लगाए गए किसी भी नए स्पेयर पार्ट्स पर मानक निर्माता वारंटी",
            ],
        },
        areas: {
            heading: "सेवा क्षेत्र",
            sub: "हम वर्तमान में सेवा देते हैं",
            list: ["कोलकाता", "सोनारपुर", "उत्तर 24 परगना", "पश्चिम बंगाल"],
            notSureTitle: "निश्चित नहीं हैं कि आपका क्षेत्र कवर है?",
            notSureText: "फोन या व्हाट्सएप पर संपर्क करें और अपना पता या पिन कोड बताएँ।",
            notSureCta: "व्हाट्सएप पर पूछें",
        },
        reviews: {
            heading: "ग्राहक समीक्षाएँ",
            title: "अभी कोई समीक्षा नहीं",
            text: "अभी तक कोई ग्राहक समीक्षा उपलब्ध नहीं है। हम केवल वास्तविक ग्राहकों की असली समीक्षाएँ प्रकाशित करते हैं।",
        },
        faq: {
            heading: "अक्सर पूछे जाने वाले प्रश्न",
            sub: "सीधे जवाब, कोई छिपी शर्त नहीं।",
            items: [
                { q: "सर्विस कैसे बुक करें?", a: "आप कॉल कर सकते हैं, व्हाट्सएप कर सकते हैं, या बुकिंग फॉर्म का उपयोग कर सकते हैं।" },
                { q: "क्या निरीक्षण शुल्क है?", a: "हाँ, तकनीशियन की विज़िट और जाँच के लिए मामूली निरीक्षण शुल्क लागू होता है। यदि आप सुझाई गई मरम्मत करवाते हैं तो यह शुल्क माफ कर दिया जाता है।" },
                { q: "क्या मरम्मत से पहले अनुमान मिलेगा?", a: "हाँ, कोई भी काम शुरू करने से पहले तकनीशियन विस्तृत जाँच और मरम्मत का अनुमान देता है। मरम्मत केवल आपकी स्वीकृति के बाद शुरू होती है।" },
                { q: "क्या स्पेयर पार्ट्स शामिल हैं?", a: "नहीं, स्पेयर पार्ट्स का शुल्क वास्तविक रिप्लेसमेंट के आधार पर अलग से लिया जाता है, जब तक कि वे किसी सक्रिय सर्विस पैकेज या मेंटेनेंस एग्रीमेंट में शामिल न हों।" },
                { q: "क्या सर्विस वारंटी है?", a: "हाँ, हम लेबर और सर्विस कारीगरी पर 30 दिनों की वारंटी देते हैं, साथ ही इंस्टॉल किए गए नए स्पेयर पार्ट्स पर मानक निर्माता वारंटी।" },
                { q: "आप कौन से भुगतान तरीके स्वीकार करते हैं?", a: "सर्विस पूरी होने पर हम नकद, यूपीआई (Google Pay, PhonePe, Paytm), नेट बैंकिंग और क्रेडिट/डेबिट कार्ड स्वीकार करते हैं।" },
                { q: "क्या आप मेरे क्षेत्र में सेवा देते हैं?", a: "हम वर्तमान में कोलकाता, सोनारपुर और उत्तर 24 परगना में सेवा देते हैं। कवरेज की पुष्टि के लिए हमसे संपर्क करें।" },
            ],
        },
        form: {
            heading: "सर्विस का अनुरोध करें",
            sub: "फॉर्म भरें, हमारी टीम शीघ्र ही आपसे संपर्क करेगी।",
            infoTitle: "डोरस्टेप विज़िट बुक करें",
            infoPoints: ["कोई भी मरम्मत से पहले तकनीशियन जाँच", "काम शुरू होने से पहले स्पष्ट अनुमान", "हमारे सेवा क्षेत्रों में 24/7 उपलब्ध"],
            labels: { fullName: "पूरा नाम", phone: "फ़ोन नंबर", areaPin: "क्षेत्र / पिन कोड", appliance: "उपकरण का प्रकार", issue: "समस्या का विवरण", date: "पसंदीदा विज़िट तारीख़", time: "पसंदीदा विज़िट समय" },
            placeholders: { fullName: "आपका पूरा नाम", phone: "जैसे 98300 00000", areaPin: "जैसे गरिया / 700084", appliance: "उपकरण चुनें", issue: "समस्या का संक्षिप्त विवरण लिखें", date: "तारीख़ चुनें", time: "समय स्लॉट चुनें" },
            applianceOptions: ["एसी", "रेफ्रिजरेटर", "माइक्रोवेव", "वाशिंग मशीन", "गीज़र / वॉटर हीटर", "आरओ वाटर प्यूरीफायर", "अन्य"],
            timeOptions: ["जितनी जल्दी हो सके", "आज — दोपहर (12–4 बजे)", "आज — शाम (4–8 बजे)", "कल — सुबह"],
            privacy: "आपकी संपर्क जानकारी का उपयोग केवल आपके सर्विस अनुरोध के जवाब के लिए किया जाएगा।",
            needDate: "कृपया विज़िट की तारीख़ चुनें।",
            submit: "सर्विस का अनुरोध करें",
            submitting: "भेजा जा रहा है…",
            successTitle: "अनुरोध प्राप्त हुआ",
            successText: "धन्यवाद। आपका सर्विस अनुरोध प्राप्त हो गया है। हमारी टीम शीघ्र ही आपसे संपर्क करेगी।",
            successWhatsApp: "व्हाट्सएप पर भी तुरंत पुष्टि करें",
            newRequest: "नया अनुरोध करें",
            error: "कुछ गलत हो गया। कृपया पुनः प्रयास करें या सीधे हमें कॉल करें।",
        },
        contact: {
            heading: "संपर्क करें",
            sub: "कभी भी संपर्क करें — हम 24/7 खुले हैं।",
            phone: "फ़ोन",
            whatsapp: "व्हाट्सएप",
            email: "ईमेल",
            hours: "कार्य समय",
            hoursValue: "24/7 खुला",
            languages: "भाषाएँ",
            languagesValue: "अंग्रेज़ी, हिंदी, बंगाली",
            instagram: "इंस्टाग्राम",
        },
        footer: {
            tagline: "कोलकाता, सोनारपुर और उत्तर 24 परगना में डोरस्टेप होम एप्लायंस रिपेयर।",
            quickLinks: "त्वरित लिंक",
            contactTitle: "संपर्क",
            rights: "ब्राइटन सर्विसेज़, कोलकाता, पश्चिम बंगाल। सर्वाधिकार सुरक्षित।",
        },
        sticky: { call: "कॉल करें", whatsapp: "व्हाट्सएप" },
    },
    bn: {
        meta: { title: "ব্রাইটেন সার্ভিসেস | কলকাতা, পশ্চিমবঙ্গে হোম অ্যাপ্লায়েন্স রিপেয়ার" },
        topbar: { service: "২৪/৭ সার্ভিস", languages: "English • हिंदी • বাংলা" },
        nav: { home: "হোম", services: "সার্ভিসসমূহ", howItWorks: "কীভাবে কাজ করে", areas: "সার্ভিস এলাকা", faqs: "সাধারণ প্রশ্ন", contact: "যোগাযোগ" },
        cta: { call: "কল করুন", alternate: "বিকল্প কল", whatsapp: "হোয়াটসঅ্যাপ", book: "সার্ভিস বুক করুন" },
        hero: {
            badge: "২৪/৭ ডোরস্টেপ সার্ভিস উপলব্ধ",
            titleLines: ["হোম অ্যাপ্লায়েন্স মেরামত", "এখন আপনার দরজায়", "কলকাতা জুড়ে"],
            subtitle: "কলকাতা, সোনারপুর এবং উত্তর ২৪ পরগনা জুড়ে গৃহস্থালী যন্ত্রপাতির দ্রুত ও সুবিধাজনক মেরামত ও রক্ষণাবেক্ষণ সহায়তা।",
            serving: "কলকাতা, পশ্চিমবঙ্গে সার্ভিস",
            card1: "২৪/৭ উপলব্ধতা",
            card2: "EN • HI • BN সহায়তা",
        },
        marquee: ["এসি রিপেয়ার", "রেফ্রিজারেটর রিপেয়ার", "মাইক্রোওয়েভ রিপেয়ার", "ওয়াশিং মেশিন", "গিজার সার্ভিস", "আরও ওয়াটার পিউরিফায়ার", "২৪/৭ ডোরস্টেপ সার্ভিস", "কলকাতা • সোনারপুর • উত্তর ২৪ পরগনা"],
        services: {
            heading: "আমাদের সার্ভিসসমূহ",
            sub: "প্রতিটি প্রয়োজনীয় গৃহস্থালী যন্ত্রের মেরামত ও রক্ষণাবেক্ষণ — মাত্র এক কল দূরে।",
            book: "এই সার্ভিসটি বুক করুন",
            commonProblems: "সাধারণ সমস্যা যা আমরা ঠিক করি",
            ctaCard: { title: "বুঝতে পারছেন না কী সমস্যা?", text: "সমস্যাটি বর্ণনা করুন — যেকোনো মেরামত শুরুর আগে টেকনিশিয়ান আপনার বাড়িতে এসে পরীক্ষা করবেন।", button: "ভিজিটের অনুরোধ করুন" },
            items: {
                ac: { title: "এয়ার কন্ডিশনার রিপেয়ার ও মেইনটেন্যান্স", tagline: "রিপেয়ার, ইনস্টলেশন ও নিয়মিত সার্ভিসিং", desc: "রিপেয়ার, ইনস্টলেশন ও নিয়মিত সার্ভিসিং দিয়ে আপনার এসি দক্ষভাবে চালিয়ে রাখুন।", problems: ["ঠিকমতো ঠান্ডা হচ্ছে না", "জল ফুটো", "গ্যাস ফুটো", "অস্বাভাবিক শব্দ", "ইনস্টলেশন সমস্যা"] },
                fridge: { title: "রেফ্রিজারেটর রিপেয়ার", tagline: "সব ধরনের রেফ্রিজারেটর", desc: "রেফ্রিজারেটরের সাধারণ ত্রুটি নির্ণয় ও মেরামত।", problems: ["কুলিং সমস্যা", "বাড়তি বরফ জমা", "কম্প্রেসর সমস্যা", "দরজার সিল সমস্যা", "তাপমাত্রা ওঠানামা"] },
                microwave: { title: "মাইক্রোওয়েভ রিপেয়ার", tagline: "সব ঘরোয়া মাইক্রোওয়েভ ওভেন", desc: "ঘরোয়া মাইক্রোওয়েভ ওভেনের মেরামত ও রক্ষণাবেক্ষণ।", problems: ["গরম হচ্ছে না", "ডিসপ্লে সমস্যা", "পাওয়ার ব্যর্থতা", "বোতাম ত্রুটি", "স্পার্কিং সমস্যা"] },
                washing: { title: "ওয়াশিং মেশিন রিপেয়ার", tagline: "সেমি ও ফুলি অটোমেটিক", desc: "সেমি-অটোমেটিক ও ফুলি-অটোমেটিক ওয়াশিং মেশিনের সার্ভিস সহায়তা।", problems: ["জল নিষ্কাশন সমস্যা", "স্পিন সমস্যা", "জল ইনলেট ত্রুটি", "কম্পন ও শব্দ", "পাওয়ার সমস্যা"] },
                geyser: { title: "গিজার রিপেয়ার ও ইনস্টলেশন", tagline: "ওয়াটার হিটার বিশেষজ্ঞ", desc: "পেশাদার ট্রাবলশুটিং ও ইনস্টলেশন সহায়তা।", problems: ["জল গরম হচ্ছে না", "জল ফুটো", "থার্মোস্ট্যাট সমস্যা", "পাওয়ার সমস্যা", "ইনস্টলেশন সহায়তা"] },
                ro: { title: "আরও ওয়াটার পিউরিফায়ার সার্ভিস", tagline: "সার্ভিস ও রক্ষণাবেক্ষণ", desc: "আরও সিস্টেমের নিয়মিত সার্ভিসিং ও মেরামত সহায়তা।", problems: ["জলের প্রবাহ কম", "ফিল্টার পরিবর্তন প্রয়োজন", "জলের মান সংক্রান্ত উদ্বেগ", "ফুটো সমস্যা", "রক্ষণাবেক্ষণ সার্ভিস"] },
            },
        },
        how: {
            heading: "কীভাবে কাজ করে",
            sub: "আপনার এবং চলন্ত যন্ত্রের মাঝে মাত্র তিনটি সহজ ধাপ।",
            steps: [
                { title: "সার্ভিস বেছে নিন", desc: "আপনার প্রয়োজনীয় অ্যাপ্লায়েন্স বা সার্ভিস নির্বাচন করুন।" },
                { title: "ভিজিট ঠিক করুন", desc: "কল করুন, হোয়াটসঅ্যাপ করুন, অথবা সার্ভিস রিকোয়েস্ট ফর্ম জমা দিন।" },
                { title: "পরিদর্শন ও মেরামতের অনুমান", desc: "টেকনিশিয়ান অ্যাপ্লায়েন্স পরীক্ষা করে কাজ শুরুর আগে মেরামতের অনুমান দেন।" },
            ],
        },
        why: {
            heading: "কেন ব্রাইটেন সার্ভিসেস",
            priority: "আপনার সন্তুষ্টিই আমাদের অগ্রাধিকার",
            sub: "সরল, সৎ ডোরস্টেপ সার্ভিস — বেশি নয়, কম নয়। আপনার সন্তুষ্টিই আমাদের অগ্রাধিকার।",
            points: [
                "২৪/৭ সার্ভিস উপলব্ধতা — বছরের প্রতিদিন",
                "ইংরেজি, হিন্দি ও বাংলায় সহায়তা",
                "যেকোনো মেরামত শুরুর আগে টেকনিশিয়ান পরিদর্শন ও সুস্পষ্ট অনুমান",
                "আমরা শ্রম ও সার্ভিস ওয়ার্কম্যানশিপে ৩০-দিনের ওয়ারেন্টি দিই, এবং লাগানো যেকোনো নতুন স্পেয়ার পার্টসে স্ট্যান্ডার্ড ম্যানুফ্যাকচারার ওয়ারেন্টি",
            ],
        },
        areas: {
            heading: "সার্ভিস এলাকা",
            sub: "আমরা বর্তমানে সার্ভিস দিই",
            list: ["কলকাতা", "সোনারপুর", "উত্তর ২৪ পরগনা", "পশ্চিমবঙ্গ"],
            notSureTitle: "নিশ্চিত নন আপনার এলাকা কভার হয় কিনা?",
            notSureText: "ফোন বা হোয়াটসঅ্যাপে যোগাযোগ করুন এবং আপনার ঠিকানা বা পিন কোড জানান।",
            notSureCta: "হোয়াটসঅ্যাপে জিজ্ঞাসা করুন",
        },
        reviews: {
            heading: "গ্রাহকদের মতামত",
            title: "এখনও কোনো রিভিউ নেই",
            text: "এখনও কোনো গ্রাহক রিভিউ দেওয়া হয়নি। আমরা শুধুমাত্র প্রকৃত গ্রাহকদের আসল রিভিউ প্রকাশ করি।",
        },
        faq: {
            heading: "সচরাচর জিজ্ঞাসিত প্রশ্ন",
            sub: "সরাসরি উত্তর, কোনো লুকানো শর্ত নেই।",
            items: [
                { q: "কীভাবে সার্ভিস বুক করবেন?", a: "আপনি কল করতে পারেন, হোয়াটসঅ্যাপ করতে পারেন, অথবা বুকিং ফর্ম ব্যবহার করতে পারেন।" },
                { q: "পরিদর্শন চার্জ আছে কি?", a: "হ্যাঁ, টেকনিশিয়ানের ভিজিট ও ডায়াগনোসিসের জন্য নামমাত্র পরিদর্শন চার্জ প্রযোজ্য। আপনি প্রস্তাবিত মেরামত করালে এই ফি মওকুফ করা হয়।" },
                { q: "মেরামতের আগে কি অনুমান পাব?", a: "হ্যাঁ, কোনো কাজ শুরুর আগে টেকনিশিয়ান বিস্তারিত পরিদর্শন ও মেরামতের অনুমান দেন। আপনার অনুমতির পরেই কেবল মেরামত শুরু হয়।" },
                { q: "স্পেয়ার পার্টস কি অন্তর্ভুক্ত?", a: "না, প্রকৃত প্রতিস্থাপনের প্রয়োজন অনুযায়ী স্পেয়ার পার্টসের চার্জ আলাদা, যদি না সক্রিয় সার্ভিস প্যাকেজ বা রক্ষণাবেক্ষণ চুক্তিতে বিশেষভাবে অন্তর্ভুক্ত থাকে।" },
                { q: "সার্ভিস ওয়ারেন্টি আছে কি?", a: "হ্যাঁ, আমরা শ্রম ও কারুশিল্পে ৩০ দিনের ওয়ারেন্টি দিই, साथে ইনস্টল করা নতুন স্পেয়ার পার্টসে প্রস্তুতকারকের মানক ওয়ারেন্টি।" },
                { q: "আপনারা কোন পেমেন্ট পদ্ধতি গ্রহণ করেন?", a: "সার্ভিস সম্পন্ন হলে আমরা নগদ, UPI (Google Pay, PhonePe, Paytm), নেট ব্যাংকিং এবং ক্রেডিট/ডেবিট কার্ড গ্রহণ করি।" },
                { q: "আপনারা কি আমার এলাকায় সার্ভিস দেন?", a: "আমরা বর্তমানে কলকাতা, সোনারপুর এবং উত্তর ২৪ পরগনায় সার্ভিস দিই। কভারেজ নিশ্চিত করতে আমাদের সাথে যোগাযোগ করুন।" },
            ],
        },
        form: {
            heading: "সার্ভিসের অনুরোধ করুন",
            sub: "ফর্মটি পূরণ করুন, আমাদের টিম শীঘ্রই আপনার সাথে যোগাযোগ করবে।",
            infoTitle: "ডোরস্টেপ ভিজিট বুক করুন",
            infoPoints: ["যেকোনো মেরামতের আগে টেকনিশিয়ান পরিদর্শন", "কাজ শুরুর আগে সুস্পষ্ট অনুমান", "আমাদের সার্ভিস এলাকায় ২৪/৭ উপলব্ধ"],
            labels: { fullName: "পুরো নাম", phone: "ফোন নম্বর", areaPin: "এলাকা / পিন কোড", appliance: "অ্যাপ্লায়েন্সের ধরন", issue: "সমস্যার বিবরণ", date: "পছন্দের ভিজিট তারিখ", time: "পছন্দের ভিজিট সময়" },
            placeholders: { fullName: "আপনার পুরো নাম", phone: "যেমন 98300 00000", areaPin: "যেমন গড়িয়া / 700084", appliance: "অ্যাপ্লায়েন্স নির্বাচন করুন", issue: "সমস্যাটি সংক্ষেপে লিখুন", date: "তারিখ নির্বাচন করুন", time: "সময় স্লট নির্বাচন করুন" },
            applianceOptions: ["এসি", "রেফ্রিজারেটর", "মাইক্রোওয়েভ", "ওয়াশিং মেশিন", "গিজার / ওয়াটার হিটার", "আরও ওয়াটার পিউরিফায়ার", "অন্যান্য"],
            timeOptions: ["যত তাড়াতাড়ি সম্ভব", "আজ — দুপুর (১২–৪টে)", "আজ — সন্ধ্যা (৪–৮টে)", "আগামীকাল — সকাল"],
            privacy: "আপনার যোগাযোগের তথ্য শুধুমাত্র আপনার সার্ভিস অনুরোধের উত্তরের জন্য ব্যবহার করা হবে।",
            needDate: "অনুগ্রহ করে ভিজিটের তারিখ নির্বাচন করুন।",
            submit: "সার্ভিসের অনুরোধ করুন",
            submitting: "জমা হচ্ছে…",
            successTitle: "অনুরোধ গৃহীত হয়েছে",
            successText: "ধন্যবাদ। আপনার সার্ভিস অনুরোধ গৃহীত হয়েছে। আমাদের টিম শীঘ্রই আপনার সাথে যোগাযোগ করবে।",
            successWhatsApp: "হোয়াটসঅ্যাপেও সাথে সাথে নিশ্চিত করুন",
            newRequest: "নতুন অনুরোধ করুন",
            error: "কিছু ভুল হয়েছে। আবার চেষ্টা করুন অথবা সরাসরি কল করুন।",
        },
        contact: {
            heading: "যোগাযোগ করুন",
            sub: "যেকোনো সময় যোগাযোগ করুন — আমরা ২৪/৭ খোলা।",
            phone: "ফোন",
            whatsapp: "হোয়াটসঅ্যাপ",
            email: "ইমেল",
            hours: "কাজের সময়",
            hoursValue: "২৪/৭ খোলা",
            languages: "ভাষা",
            languagesValue: "ইংরেজি, হিন্দি, বাংলা",
            instagram: "ইনস্টাগ্রাম",
        },
        footer: {
            tagline: "কলকাতা, সোনারপুর ও উত্তর ২৪ পরগনায় ডোরস্টেপ হোম অ্যাপ্লায়েন্স রিপেয়ার।",
            quickLinks: "দ্রুত লিংক",
            contactTitle: "যোগাযোগ",
            rights: "ব্রাইটেন সার্ভিসেস, কলকাতা, পশ্চিমবঙ্গ। সর্বস্বত্ব সংরক্ষিত।",
        },
        sticky: { call: "কল করুন", whatsapp: "হোয়াটসঅ্যাপ" },
    },
};
